// extracted by mini-css-extract-plugin
export default {"highlights":"highlights_highlights__yayJ7","box":"highlights_box__zKLAZ","icon":"highlights_icon__i8DG7","title":"highlights_title__URV+y","checked":"highlights_checked__fudMe"};